import '../Home/Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import React, { Component } from "react";
import withNavigateHook from '../../myRoutes';
import axios from 'axios';
import Select from 'react-select';
//import { parse } from 'next/dist/build/swc/generated-native';

class Mycases extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            startdate: "",// new Date(),
            enddate: "", // new Date(),
            selectedDate: new Date(),
            userRole: "",
            firstname: "",
            lastname: "",
            db: "",
            email: "",
            caseid: "",
            casecategory: "",
            casestatus: "",
            casename: "",
            caseoption: "",
            caseamount: 0,
            casedescription: "",
            groupCases: [],
            casesCount: "",
            myPendingCases: [],
            caseDetails: [],
            voluntamount: 0,
            casesStatuses: [],
            groupMembers: "",
            uploadStatus: "",
            selectedFile: "",
            fileurl: "",
            savefeedback: "",
            remove: "",
        }
    }
    componentDidMount = () => {
        this.setState({
            db: this.props.location.state.db, firstname: this.props.location.state.firstname,
            email: this.props.location.state.email, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
        });
        this.loadGroupCases();
        this.getAllCaseStatuses();
        this.loadPendingPayCases();
        this.loadGroupAllMembers();
    }


    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/mycases', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }

    appLogout = (e) => {
        //  e.preventDefault();
        this.props.navigate('/', { replace: true, state: { db: '', email: '', firstname: '' } });
    }

    loadGroupAllMembers = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }

        }
        // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupAllmemberships.php";
        const response = await axios.get(url, config);
        //  console.log(response.data);
        this.setState({ groupMembers: response.data });
    }
    goToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                db: this.props.location.state.db, email: this.props.location.state.email,
                firstname: this.props.location.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }

    setMyCaseChange = (caseid) => {
        this.loadCaseDetails(caseid);
        this.setState({ caseid: caseid });
    }

    loadCaseDetails = async (caseid) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "businessname": this.props.location.state.db,
                "caseid": caseid
            }
        }
        //const url = "http://localhost/kimvuka-php/api/getCaseDetails.php";
        const url = "https://testmembership.bktsystems.com/api/getCaseDetails.php";
        const response = await axios.get(url, config);

        if (Array.isArray(response.data)) {
            this.setState({
                casecategory: response.data[0]['category'], startdate: response.data[0]['startdate'], enddate: response.data[0]['enddate'],
                amount: parseFloat(response.data[0]['amount']).toFixed(2), caseoption: response.data[0]['caseoption'],
            });
            if (response.data[0]['caseoption'] === 'Voluntary') {
                // console.log('I a here>>>>')
                document.getElementById('amount_').style.display = 'none';
                document.getElementById('paidfull').checked = true;
                document.getElementById('volamount').style.display = 'block';
                document.getElementById('paidpart').disabled = true;
                this.setState({ casestatus: "Paid" });
            }
            if (response.data[0]['caseoption'] === 'Mandatory') {
                document.getElementById('amount_').style.display = 'block';
                document.getElementById('paidfull').checked = false;
                document.getElementById('paidpart').disabled = false;
                document.getElementById('volamount').style.display = 'none';
            }
        }
    }
    handlePaidFull = (e) => {
        if (e.target.checked === true) {
            document.getElementById('paidpart').checked = false;
            this.setState({ casestatus: "Paid" });
        }
    }
    handlePaidPart = (e) => {
        if (e.target.checked === true) {
            document.getElementById('paidfull').checked = false;
            this.setState({ casestatus: "Partially paid" });
        }
    }
    setVoluntaryAmtPaid = (event) => {
        // console.log('----' + event.target.value)
        this.setState({ volamount: event.target.value })
    }

    handleAmountChange = (e) => {

        this.setState({
            voluntamount: parseFloat(e.target.value)
        })
        //  console.log(e.target.value)
    }

    // File upload-------

    handleFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    };

    handleUpload = async () => {
        if (this.state.caseid === "") {
            alert('Please select a case')
            this.setState({ uploadStatus: 'Please select a case' });
            return;
        }
        if (!this.state.selectedFile) {
            alert('Please select a file')
            this.setState({ uploadStatus: 'Please select a file' });
            return;
        }
        else {
            const formData = new FormData();
            const fileExtensions = ["PDF", "pdf", "PNG", "png", "JPEG", "jpeg", "JPG", "jpg"];
            formData.append('file', this.state.selectedFile)
            formData.append('caseid', this.state.caseid);
            formData.append('email', this.state.email);
            formData.append('businessname', this.props.location.state.db);

            if (!fileExtensions.includes((this.state.selectedFile.type).split("/")[1])) {
                alert('Only PDF, PNG and JPEG files allowed!')
                this.setState({ uploadStatus: 'Please select a valid file  to upload' });
                return false;
            }
            else {
                try {
                    this.setState({ uploadStatus: 'Uploading...' });
                    const response = await axios.post('https://testmembership.bktsystems.com/api/files.php', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },

                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            this.setState({ uploadStatus: `Uploading: ${percentCompleted}%` });
                        },
                    });

                    if (response.status === 200) {
                        this.setState({ uploadStatus: 'Upload successful!', fileurl: response.data, selectedFile: response.data });
                        document.getElementById('btnUpload').style.display = 'none'
                        document.getElementById('btnRemove').style.display = 'block';
                        // console.log(response.data)
                    } else {
                        this.setState({ uploadStatus: 'Upload failed!' });
                    }
                } catch (error) {
                    this.setState({ uploadStatus: 'Error uploading file!' });
                    console.error(error);
                }
            }
        }
    };


    getAllCaseStatuses = async (e) => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "businessname": this.props.location.state.db
            }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupCaseStatus.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupCaseStatus.php";
        const response = await axios.get(url, config);
        //console.log('All case status-------')
        //console.log(response.data);
        this.setState({ casesStatuses: response.data })

    }
    handleRemove = async (e) => {
        if (this.state.fileurl === "") {
            alert('No file to delete found!')
            return false;
        }
        else {

            let config = {
                headers: { 'Accept': 'application/json' },
                params: { "businessname": this.props.location.state.db, filetoremove: this.state.fileurl, remove: "remove" }

            }
            // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
            const url = "https://testmembership.bktsystems.com/api/files.php";
            const response = await axios.get(url, config);
            //  console.log(response.data);
            if (response.status === 200) {
                this.setState({ fileurl: "", uploadStatus: response.data, remove: "", selectedFile: "" })
                document.getElementById('btnRemove').style.display = 'none';                
                document.getElementById('uploadInput').value = null;
                document.getElementById('btnUpload').style.display = 'block';
            }

        }

    }
    updateMyCase = async () => {
        if (this.state.casestatus === "") {
            alert("Please select paid option!" + this.state.casestatus);
            return false;
        }
        if ((this.state.caseoption === 'Voluntary') && (this.state.voluntamount === 0)) {
            alert("Please enter the amount paid!");
            return false;
        }
        else {
            //console.log('----------' + this.props.location.state.email)
            let config = {
                headers: { 'Accept': 'application/json' },
                params: {
                    "businessname": this.props.location.state.db,
                    "firstname": this.state.firstname,
                    "caseid": this.state.caseid,
                    "caseoption": this.state.caseoption,
                    "caseamount": this.state.amount,
                    "volutamount": this.state.voluntamount,
                    "casestatus": this.state.casestatus,
                    "email": this.state.email,
                    "fileurl": this.state.fileurl
                }
            }
            // const url = "http://localhost/kimvuka-php/api/saveCaseStatus.php";
            const url = "https://testmembership.bktsystems.com/api/saveCaseStatus.php";
            const response = await axios.get(url, config);
            console.log('Save case status feedback')
            this.setState({ savefeedback: 'Case successfully saved!' })
            // console.log(response.data);
            document.getElementById('btnSubmit').style.display = 'none';
        }
    }

    loadGroupCases = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupCases.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupCases.php";
        const response = await axios.get(url, config);
        if (Array.isArray(response.data)) {
            this.setState({ groupCases: response.data });
        }

        if (response.data === 'No data found') {
            this.setState({ casesCount: response.data })
        }

        //console.log(response.data)

    }
    //LOAD PENDING PAY COMBO
    loadPendingPayCases = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "businessname": this.props.location.state.db,
                "email": this.props.location.state.email,

            }
        }
        //const url = "http://localhost/kimvuka-php/api/getMemberPendingCases.php";
        const url = "https://testmembership.bktsystems.com/api/getMemberPendingCases.php";
        const response = await axios.get(url, config);

        if (Array.isArray(response.data)) {
            response.data.map(key => {

                this.state.myPendingCases.push({
                    label: key.name, value: key.id
                });

            })
        }

    }

    // GET CASE PAY STATUS
    getCasePayStatus = (caseid) => {
        let payStatus = 'Not paid';
        let memberId = 0;
        for (let j = 0; j < this.state.groupMembers.length; j++) {
            if (this.props.location.state.email === this.state.groupMembers[j].email) {
                memberId = this.state.groupMembers[j].id;
                break;
            }
        }
        //console.log(this.state.casesStatuses);
        for (let i = 0; i < this.state.casesStatuses.length; i++) {
            if ((caseid === this.state.casesStatuses[i].caseid) && (memberId === this.state.casesStatuses[i].memberid)) {
                payStatus = this.state.casesStatuses[i].status
                // console.log(this.state.casesStatuses[i].status);
                break;
            }
        }
        return payStatus;
    }


    render() {
        return (
            <div id="MycasesDiv" className='mainDivHome' style={{ border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                <div style={{ width: "100%" }}>
                    <span>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "white", fontStyle: "italic" }} onClick={this.goToMenu}>Main Menu</Button>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </span>
                </div>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                </div>
                <div>
                    <div style={{ textAlign: "center", paddingTop: "5px" }}><Label> <h4>MY CASE LIST</h4></Label></div>
                </div>
                <div style={{ paddingBottom: "10px" }}>
                    <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
                        <span className=""><h5>MY CASES {this.state.casesCount}</h5></span>
                    </div>
                    <table style={{ borderBottom: "1px solid white", width: "100%" }}><thead>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>No</th>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Category</th>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Type</th>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Name</th>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Amount</th>
                        <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Status</th>
                    </thead><tbody>
                            {/* {this.state.membersData.map(function (item) { */}
                            {this.state.groupCases.map((item, index) => {
                                return (<tr style={{ height: "5px", color: "darkblue", borderBottom: "1px solid white", borderTop: "1px solid white", cursor: "pointer" }}
                                    // key={item.id} onClick={() => this.openDetails(item.userid)}>
                                    key={item.id}>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>{item.id}</td>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.category}</td>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.caseoption}</td>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.name}</td>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", }}>{parseFloat(item.amount).toFixed(2)}</td>
                                    <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", }}>{this.getCasePayStatus(item.id)}</td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                    <div style={{ paddingTop: "20px", paddingBottom: "5px" }}><span className=""><h5>UPDATE MY CASES</h5></span></div>
                    <div>
                        <div style={{ paddingTop: "5px", paddingBottom: "5px", textAlign: "center" }}>
                            {(() => {
                                if (this.state.myPendingCases.length === 1) {
                                    return (<span style={{ color: "#ff7400", fontStyle: "italic" }}><h5>You have {this.state.myPendingCases.length} case not paid!</h5></span>)
                                }
                                if (this.state.myPendingCases.length > 1) {
                                    return (<span style={{ color: "#ff7400", fontStyle: "italic" }}><h5>You have {this.state.myPendingCases.length} cases not paid!</h5></span>)
                                }
                                if (this.state.myPendingCases.length === 0) {
                                    return (<span style={{ color: "green", fontStyle: "italic" }}><h5>You have no case not paid!</h5></span>)
                                }
                            })()}

                        </div>
                        <FormGroup>
                            <Label for='mycases'>Select case</Label>
                            <Select
                                options={this.state.myPendingCases}
                                maxMenuHeight="100%"
                                // defaultInputValue={this.props.memberGender}
                                onChange={opt => this.setMyCaseChange(opt.value)}
                            // value={this.props.memberGender}
                            //  key={this.props.memberGender}
                            ></Select>
                        </FormGroup>
                        <FormGroup>
                            <Label for='caseopption'>Case option</Label>
                            <Input
                                type='text'
                                id='caseopption'
                                name='caseopption'
                                value={this.state.caseoption}
                                readOnly={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='casecategory'>Category</Label>
                            <Input
                                type='text'
                                id='casecategory'
                                name='casecategory'
                                value={this.state.casecategory}
                                readOnly={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='casestart'>Start date</Label>
                            <Input
                                type='text'
                                id='casecategory'
                                name='casecategory'
                                value={this.state.startdate}
                                readOnly={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='casend'>End date</Label>
                            <Input
                                type='text'
                                id='casend'
                                name='casend'
                                value={this.state.enddate}
                                readOnly={true}
                            />
                        </FormGroup>
                        <div id='amount_'>
                            <FormGroup>
                                <Label for='amount'>Amount</Label>
                                <Input
                                    type='text'
                                    id='amount'
                                    name='amount'
                                    value={this.state.amount}
                                    readOnly={true}
                                />
                            </FormGroup>
                        </div>

                        <div id='volamount'>
                            <FormGroup>
                                <Label for='voluntaryAmount'>Amount</Label>
                                <Input style={{ borderBlockColor: "red" }}
                                    type='number'
                                    id='voluntamount'
                                    name='voluntamount'
                                    value={parseFloat(this.state.voluntamount).toFixed(2)}
                                    onChange={this.handleAmountChange}
                                />
                            </FormGroup>
                        </div>
                        <div id='btnUpload' style={{ width: "100%", paddingBottom: "5px" }}>
                            <span><Label for='pop'>**Upload proof of payment</Label></span><br />
                            <input id="uploadInput" style={{ width: "50%" }} type="file" onChange={this.handleFileChange} />
                            <Button  style={{ width: "50%", height: "40px" }} onClick={this.handleUpload}>Upload</Button>                           
                            <p>{this.uploadStatus}</p>
                            <label>{this.state.uploadStatus}</label>
                        </div>
                        <div id='btnRemove' style={{ width: "100%", paddingBottom: "5px", display: "none" }}>
                            <span><Label for='pop'>**Uploaded file</Label></span><br />
                            <label style={{color:"red"}}><a href={'../../../files/'+this.state.fileurl}
                            target=' _blank'>{this.state.fileurl}</a></label>
                            <Button  style={{ width: "50%", height: "40px", color: "red", float:"right" }} onClick={this.handleRemove}>Removexx</Button>
                            <p>{this.uploadStatus}</p>
                            <label>{this.state.uploadStatus}</label>
                        </div>
                        <div style={{ paddingTop: "2px", textAlign: "center" }}><label>{this.state.savefeedback}</label></div>
                        <div>
                            <div id="payDiv" style={{
                                paddingTop: "20px", paddingBottom: "15px", border: "1px solid gray", paddingLeft: "5px", paddingRight: "5px",
                                borderRadius: "20px"
                            }} >
                                <span style={{ paddingRight: "10px" }}>
                                    <label>
                                        <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                            type='checkbox'
                                            name='paidfull'
                                            id='paidfull'
                                            /* defaultChecked={true} */
                                            onChange={this.handlePaidFull}
                                        />
                                        Paid full
                                    </label>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                    <label>
                                        <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                            type='checkbox'
                                            name='paidpart'
                                            id='paidpart'
                                            onChange={this.handlePaidPart}
                                        />
                                        Partially paid
                                    </label>
                                </span>
                                <div id="btnSubmit" style={{ paddingTop: "20px", alignItems: 'center' }}>
                                    <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", color: 'white', fontWeight: "bold" }} onClick={this.updateMyCase}>Submit</Button>
                                </div>
                                <div style={{ alignItems: "center", paddingTop: "20px", float: "center" }}>
                                    <Button style={{ width: "100%", fontWeight: "bold" }}
                                        onClick={this.goToMenu}>
                                        Close
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>);
    }
}
export default withNavigateHook(Mycases)